import { newValidator, validateNotBlank, validateEmail, validateRequired } from 'simple-valley'
import ugcCaptionValidator from './ugcCaptionValidator.js'
import ugcDateValidator from './ugcDateValidator.js'

export default function ugcCreateValidator(ugc) {
  let v = newValidator(ugc)
  v = validateNotBlank(v, ['name', 'orgId'])
  v = validateNotBlank(v, 'appId', { message: 'exhibitId blank' })
  v = validateRequired(v, 'assetId')
  v = validateEmail(v, 'email')
  v = validateRequired(v, 'caption')
  v = validateRequired(v, 's3Files')
  v = ugcCaptionValidator(v)
  v = ugcDateValidator(v)
  v = validateRequired(v, 'desc')
  v = validateRequired(v, 'locationName')
  v = validateRequired(v, 'lat')
  v = validateRequired(v, 'lng')

  return v
}
